export default __webpack_public_path__ + "static/banner-webdesign-5e91aaf71518bb257fa0cb262f20e61a.jpg";